module.exports = __webpack_public_path__ + "img/amazon_retail_uae.337eb0fd.svg";